import { COMPANY_PROJECT_TYPES_ENUM } from '@woovi/roles';

export const COMPANY_PROJECT_TYPES_VALUES = {
  [COMPANY_PROJECT_TYPES_ENUM.OPEN_PIX]: {
    name: 'OpenPix',
    value: COMPANY_PROJECT_TYPES_ENUM.OPEN_PIX,
  },
  [COMPANY_PROJECT_TYPES_ENUM.WOOVI]: {
    name: 'Woovi',
    value: COMPANY_PROJECT_TYPES_ENUM.WOOVI,
  },
};
